import {
  REQUEST,
  SUCCESS,
  FAILURE,
  SOCKET,
} from 'flaivy-react/reducers/action-type';
import { ACTION_TYPES } from '../actions/generated/supplier-sales-report.actions';

const initialState = {
  loading: false,
  entity: {},
  error: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SUPPLIER_SALES_REPORT):
    case REQUEST(ACTION_TYPES.UPSERT_SUPPLIER_SALES_REPORT): {
      return {
        ...state,
        loading: true,
      };
    }
    case FAILURE(ACTION_TYPES.FETCH_SUPPLIER_SALES_REPORT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SUPPLIER_SALES_REPORT):
    case FAILURE(ACTION_TYPES.UPSERT_SUPPLIER_SALES_REPORT): {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_SUPPLIER_SALES_REPORT): {
      const entity = action.payload;
      return {
        ...state,
        entity,
        loading: false,
      };
    }
    case SOCKET('SUPPLIER_SALES_REPORT_CANCELLED'):
    case SOCKET('SUPPLIER_SALES_REPORT_UPDATED'): {
      const { fullEntity } = action.payload;
      if (fullEntity.id === state.entity.id) {
        return {
          ...state,
          entity: fullEntity,
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

export default reducer;
